var $f033322c769d9228$exports = {};
$f033322c769d9228$exports = {
    "Empty": `Pusty`
};


export {$f033322c769d9228$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
